import React from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { PageTabsBar } from '@/components/layouts/PageHeader/PageTabsBar';
import { UserImportResultsTable } from './ResultsTable';
import { UserImportLog } from './LogTable';
import { UserImportDownloads } from './UserImportDownloads';

const RESULTS_TAB = 'results';
const LOG_TAB = 'log';
const REPORT_TABS = [
	{ label: 'Results', value: RESULTS_TAB },
	{ label: 'Log', value: LOG_TAB },
];

/**
 * The user import report's Results (UserImportResultsTable) and Log (UserImportLog) tabs,
 * kept in the URL (?tab=log), with downloads of both beside them (UserImportDownloads).
 */
export const UserImportReportTabs = ({ importId }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const tab = searchParams.get('tab') === LOG_TAB ? LOG_TAB : RESULTS_TAB;

	return (
		<Box>
			<PageTabsBar
				tabs={REPORT_TABS}
				value={tab}
				queryParam='tab'
				// The tabs' links only work for new tabs (ctrl / cmd-click); a plain click is
				// handled here
				onChange={(event, nextTab) => setSearchParams({ tab: nextTab }, { replace: true })}
				actions={<UserImportDownloads importId={importId} />}
			/>
			<Box sx={{ pt: 1 }}>
				{tab === LOG_TAB ? (
					<UserImportLog importId={importId} />
				) : (
					<UserImportResultsTable importId={importId} />
				)}
			</Box>
		</Box>
	);
};
